import $ from "jquery";
import "jquery-ui-bundle";

if (document.getElementById("rangeslider")) {
  $("#rangeslider").slider({
    range: true,
    min: 2002,
    max: new Date().getFullYear(),
    values: [
      (document.getElementById("js-range-slider-min") as HTMLInputElement)
        .value,
      (document.getElementById("js-range-slider-max") as HTMLInputElement)
        .value,
    ],
    slide(event, ui) {
      $("#js-range-slider-min").val(ui.values[0]);
      $("#js-range-slider-max").val(ui.values[1]);
    },
  });
}
